// @copyright  2006 - 2022 West Indies Software Engineering Company Limited. All rights reserved.

export default {
    '$dir': 'ltr',

    'sale.page.title': 'Sales',
    'sale.page.search_results': 'Search Results',
    'sale.page.create.title': 'New Sale',
    'sale.page.search.title': 'Find Sales',
    'sale.page.edit.title': 'Edit Sale',
    'sale.page.edit.email': 'Email Sale',
    'sale.page.view.history': 'Audit Trail',
    'sale.page.all': 'All',

    'sale.button.cancel': 'Cancel',
    'sale.button.select': 'Select',
    'sale.button.find': 'Find Sales',
    'sale.button.search': 'Apply',
    'sale.button.create': 'Checkout',
    'sale.button.draft': 'Save as Draft',
    'sale.button.pro_forma': 'Save as Pro Forma',
    'sale.button.print': 'Print',
    'sale.button.email': 'Email',
    'sale.button.send_email': 'Send Email',
    'sale.button.new': 'New Sale',
    'sale.button.cancel_draft': 'Cancel Draft',
    'sale.button.void': 'Void Sale',
    'sale.button.rollback': 'Rollback Sale',
    'sale.button.save': 'Save Changes',
    'sale.button.delete': 'Permanently Delete',
    'sale.button.edit': 'Edit',
    'sale.button.restore': 'Restore',
    'sale.button.refund': 'Refund',
    'sale.button.reset': 'Reset',
    'sale.button.record_payment': 'Record Payment',
    'sale.button.history': 'Audit Trail',
    'sale.button.credit_memo': 'View Credit Memo',

    'sale.placeholder.search': 'Search sales',
    'sale.placeholder.search_items': 'Search items',

    'sale.message.no_change': 'This sale has not changed since it was created.',

    'sale.link.create_first_sale': 'Click here to create your first sale',
    'sale.link.sales': ' Return to Sales',
    'sale.link.retry': 'Click here to retry',

    'sale.checkbox.all': 'Check All',
    'sale.checkbox.actions_label': 'with selected',

    'sale.label.items': 'Sale Items',
    'sale.label.recent': 'Recent',
    'sale.label.popular': 'Popular',
    'sale.label.date': 'Date',
    'sale.label.due': 'Due',
    'sale.label.item': 'Item',
    'sale.label.unit_cost': 'Unit Cost',
    'sale.label.quantity': 'Quantity',
    'sale.label.total': 'Total',
    'sale.label.tax_total': 'Tax Total',
    'sale.label.grand_total': 'Grand Total',
    'sale.label.amount_paid': 'Amount Paid',
    'sale.label.change_due': 'Change Due',
    'sale.label.sub_total': 'Subtotal',
    'sale.label.discount': 'Discount',
    'sale.label.bill_to': 'Bill To',
    'sale.label.bill_to_province': 'Bill To Province',
    'sale.label.balance': 'Balance',
    'sale.label.subject': 'Subject',
    'sale.label.to': 'To',
    'sale.label.message': 'Message',
    'sale.label.no_items': 'No items found',
    'sale.label.void_reason': 'Reason for voiding sale',
    'sale.label.cancel_reason': 'Reason for canceling sale',
    'sale.label.refund_reason': 'Reason for refunding sale',
    'sale.label.rollback_reason': 'Reason for rolling back sale',

    'sale.label.sale_number': 'Sale No',
    'sale.label.issue_credit': 'Give store credit?',

    'sale.label.draft_sale': 'Draft Sale',
    'sale.label.proforma_sale': 'Pro Forma Sale',
    'sale.label.sale': 'Sale',

    'sale.label.title': 'Title',
    'sale.label.refunded_on': 'Refund On',

    'sale.label.from__transaction_date': 'From transaction date',
    'sale.label.to__transaction_date': 'To transaction date',
    'sale.label.transaction_date': 'Sale Date',

    'sale.label.printed_at': 'Printed At',
    'sale.label.opened_at': 'Opened At',
    'sale.label.paid_at': 'Paid At',
    'sale.label.due_at': 'Due Date',

    'sale.label.bill_to_entity_name': 'Bill To',
    'sale.label.bill_to_contact_name': 'Bill To Contact',
    'sale.label.bill_to_address': 'Bill To Address',
    'sale.label.ship_to_contact_name': 'Ship To Contact',
    'sale.label.ship_to_address': 'Ship To Address',
    'sale.label.purchase_order_number': 'Purchase Order #',
    'sale.label.currency_name': 'Currency',
    'sale.label.currency_sub_total_in_cents': 'Subtotal',
    'sale.label.currency_discount_total_in_cents': 'Discount Total',
    'sale.label.currency_tax_total_in_cents': 'Tax Total',
    'sale.label.currency_grand_total_in_cents': 'Grand Total',
    'sale.label.currency_balance_owing_in_cents': 'Balance Owing',
    'sale.label.currency_shipping_total_in_cents': 'Shipping Total',

    'sale.label.sold_by': 'Sales Person',
    'sale.label.public_customer_message': 'Public Customer Message',
    'sale.label.private_note': 'Private Note',
    'sale.label.reference_number': 'Reference Number',

    'sale.label.created_at': 'Created on',

    'sale.label.status': 'Status',

    'sale.sort.field_label': 'Field',
    'sale.sort.direction_label': 'Direction',
    'sale.sort.direction_ascending': 'Ascending',
    'sale.sort.direction_descending': 'Descending',

    'sale.modal.title.sale_void': 'Void Sale',
    'sale.modal.title.sale_cancel': 'Cancel Draft Sale',
    'sale.modal.title.sale_rollback': 'Rollback Sale',
    'sale.modal.title.sale_refund': 'Refund Sale',
    'sale.modal.title.sale_restore': 'Restore Sale',

    'sale.modal.message.sale_cancel': 'Are you sure that you want to cancel this draft? This action cannot be undone.| Are you sure that you want to cancel these drafts? This action cannot be undone.',
    'sale.modal.message.sale_void':
        'Are you sure that you want to void this sale? This action cannot be undone and a credit note will be issued for payments. | Are you sure that you want to void these sales? This action cannot be undone and a credit note will be issued for payments.',
    'sale.modal.message.sale_rollback': 'Are you sure that you want to rollback this sale? This action cannot be undone. | Are you sure that you want to void these sales? This action cannot be undone',
    'sale.modal.message.sale_restore': 'Are you sure that you want to restore this sale? | Are you sure that you want to restore these sales?',
    'sale.modal.message.sale_refund': 'Are you sure that you want to refund this sale? | Are you sure that you want to refund these sales?',

    'sale.success.message.sale_created': 'Your sale has been created',
    'sale.success.message.sale_updated': 'Your sale has been updated',
    'sale.success.message.sale_cancelled': 'Your draft sale has been cancelled',
    'sale.success.message.sale_voided': 'Your sale has been voided',
    'sale.success.message.sale_rolled_back': 'Your sale has been rolled back',
    'sale.success.message.sale_restored': 'Your sale has been restored | All selected sales were restored',
    'sale.success.message.sale_refunded': 'Your sale has been refunded | All selected sales were refunded',
    'sale.success.message.sale_deleted': 'Your sale has been permanently deleted | All selected sales were permanently deleted',

    'sale.error.message.already_refunded': 'This sale has already been refunded — its goods have been returned, so it cannot be refunded again.',
    'sale.error.message.sale_deleted': 'This sale was already permanently deleted | These sales were already permanently deleted',
    'sale.error.message.sale_restored': 'This sale was already restored | These sales were already restored',
    'sale.error.message.error_loading_page': 'Sorry, there was an error loading sale.| Sorry, there was an error loading sales.',
};
